import { useAuth } from "./user-auth";
import { createConsoleClient } from "@/lib/appwrite-client";

const REFRESH_INTERVAL = 1000 * 60 * 7; // 7 minutes
const CONSOLE_AUTH_TOKEN_STORAGE_KEY = `imagine-auth-token`;

const generateConsoleAuthToken = async () => {
  const client = createConsoleClient();
  const token = await client.account.createJWT();
  return token.jwt;
};

export function clearConsoleAuthToken() {
  localStorage.removeItem(CONSOLE_AUTH_TOKEN_STORAGE_KEY);
}

export async function getConsoleAuthToken({
  forceRefresh = false,
}: { forceRefresh?: boolean } = {}) {
  const tokenInLocalStorage = localStorage.getItem(
    `${CONSOLE_AUTH_TOKEN_STORAGE_KEY}`,
  );

  if (tokenInLocalStorage) {
    const payload = tokenInLocalStorage.split(".")[1]!;
    const decodedPayload = atob(payload);
    const parsedPayload = JSON.parse(decodedPayload);

    const tokenExp = Number(`${parsedPayload.exp}000`);
    const currentTimeUTC = Date.now();

    if (currentTimeUTC >= tokenExp - REFRESH_INTERVAL || forceRefresh) {
      const newToken = await generateConsoleAuthToken();
      localStorage.setItem(`${CONSOLE_AUTH_TOKEN_STORAGE_KEY}`, newToken);
      return newToken;
    } else {
      return tokenInLocalStorage;
    }
  } else {
    const token = await generateConsoleAuthToken();
    localStorage.setItem(`${CONSOLE_AUTH_TOKEN_STORAGE_KEY}`, token);
    return token;
  }
}
